module.exports = __webpack_public_path__ + "static/media/Sherbir-Panag.2dc5bfd7.png";